<template>
  <div class="top-level-menu-status-item-wrapper">
    <div :class="[classes, { 'has-agent-timer-inside-menu': shouldDisplayTimerInsideMenu}]" @click="clicked" role="button" tabindex="0" @keydown.enter.space.prevent="clicked" :aria-expanded="canExpand && expanded" :aria-pressed="isSelected">
      <div v-bind:class="iconClasses"></div>
      <div class="top-level-menu-status-title">
        <span class="top-level-menu-status-text ellipsis">{{statusItem.availabilityTitle}}</span>
        <span v-bind:class="arrowIconClasses"></span>
      </div>
      <AgentTimer v-if="hasStatusTimer"
                  :shouldDisplayTimerInsideMenu="shouldDisplayTimerInsideMenu"
                  :statusItem="statusItem"
                  :selectedItem="selectedItem"
                  :isFirstStatusAfterLogin="isFirstStatusAfterLogin"
                  @makeFirstStatusFalse="makeFirstStatusFalse"></AgentTimer>
    </div>
  </div>
</template>

<script>

  import AgentTimer from "./AgentTimer";
  const Settings = require("codeTables/settings.json");

  export default {
    name: "top-level-menu-status-item-view",
    components: {AgentTimer},
    props: {
      statusItem: {
        type: Object
      },
      selectedItem: {
        type: Object
      },
      expanded: {
        type: Boolean,
      },
      canExpand: {
        type: Boolean,
        default: false,
      },
      isFirstStatusAfterLogin: {
        type: Boolean,
        default: true,
      },
      hasConfigForCustomMaxSize: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        shouldDisplayTimerInsideMenu: false,
      }
    },
    computed: {
      isSelected() {
        return this.statusItem.value === this.selectedItem.value;
      },
      classes() {
        return {
          'top-level-menu-status-item': true,
          selected: this.isSelected,
        };
      },
      iconClasses() {
        let imageClass;
        if(this.statusItem.imageClass === 'online'){
          imageClass = 'ico-agent-status-online online'
        }
        else if(this.statusItem.imageClass === 'brb'){
          imageClass = 'ico-agent-status-back-soon brb'
        }
        else if(this.statusItem.imageClass === 'away'){
          imageClass = 'ico-agent-status-away away'
        }

        return {
          'top-level-menu-status-icon': true,
          [imageClass]: true
        };
      },
      arrowIconClasses() {
        return {
          'top-level-menu-status-arrow-icon ico-arrow-down': true,
          'hide': !this.statusItem.customReasonsAvailable,
        };
      },
      hasStatusTimerInsideMenu() {
        // AC FEATURE
        const agentStatusTimer = LE.sessionManager.hasAgentTimer();

        // PERMISSION
        const viewAgentStatusTimer = LE.siteSettings.privilegeSettings.hasAgentTimerPrivilege();

        // SITE SETTING
        const agentStatusTimerInsideMenu = LE.sessionManager.getAccountSettingValueByID(Settings.SETTING_ID.AGENT_STATUS_TIMER_INSIDE_MENU);

        return (agentStatusTimer && viewAgentStatusTimer && agentStatusTimerInsideMenu === 'true');
      },
      hasStatusTimer() {
        const agentStatusTimerUnderMenu = LE.sessionManager.getAccountSettingValueByID(Settings.SETTING_ID.AGENT_STATUS_TIMER_UNDER_MENU);
        if (!this.hasStatusTimerInsideMenu) {
          this.shouldDisplayTimerInsideMenu = false;
          return agentStatusTimerUnderMenu === 'true';
        } else {
          this.shouldDisplayTimerInsideMenu = true;
          return true;
        }
      }
    },
    methods: {
      makeFirstStatusFalse() {
        this.$emit('setFirstStatusToFalse');
      },
      clicked() {
        // for the case the status upon login is Away and before getting the api response the user clicks on another status.
        // in this case we need to make sure isFirstStatusAfterLogin is set to false
        // it makes sense either way cause when the user clicks on a new status it is for sure not the first status
        // we also have to make sure the clicked item is not Away otherwise we wouldn't want to change anything
        if (this.isFirstStatusAfterLogin && this.statusItem.value !== 'Away') {
          this.makeFirstStatusFalse();
        }
        this.$emit('clicked', this.statusItem);
      },
    },
  }
</script>

<style lang='scss' scoped>

</style>
